import React from 'react';
import { TelegramCircleIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { IDTMResult } from 'modules/dtm-test/models';
import { globalConst } from 'modules/global';
import { IProfile } from 'modules/national-certificate-result';

import ActionSection from './action-section';
import ResultImage from './result-image';
import ResultStatistics from './result-statistics';

interface IProps {
  ticketId?: string;
  results?: IDTMResult;
  profile?: IProfile;
}

export const DtmResult: React.FC<IProps> = ({ results, ticketId, profile }) => {
  const t = useTranslations();

  return (
    <div className="rounded-xl bg-white p-4">
      <ResultImage passingScore={results?.passing_ball} score={results?.right} />
      <p className="my-4 text-center text-lg font-medium">{profile?.full_name}</p>

      <div className="mx-auto max-w-80">
        <ResultStatistics
          earnedScore={results?.earned_ball}
          incorrectAnswers={results?.false}
          correctAnswersCount={results?.right}
        />
      </div>

      <Link
        target="_blank"
        href={`${process.env.NEXT_PUBLIC_TELEGRAM}`}
        className="relative mt-4 block rounded-xl !bg-green-100 p-3 text-center text-xs font-medium !text-gray-800"
      >
        {t.rich('talim_yangiliklaridan_xabardor_bolish_uchun_telegram_kanalimizga_qoshiling', {
          span: chunks => <span className="text-blue-500">{chunks}</span>
        })}
        <div className="absolute -right-2 -top-2">
          <TelegramCircleIcon />
        </div>
      </Link>

      <ActionSection ticketId={ticketId as string} />

      <div className="mt-10 flex items-center gap-3 md:justify-between">
        <Link
          href={globalConst.pageNames.DTM}
          className="md:w-30 max-w-34.5 flex w-full items-center justify-center rounded-lg border-none bg-gray-100 py-1.5 text-sm font-medium text-gray-800 hover:border-none"
        >
          {t('qayta_ishlash')}
        </Link>
        <Link
          href="/"
          className="md:w-30 flex w-full items-center justify-center rounded-lg border-none bg-green-500 py-1.5 text-sm font-medium text-white hover:border-none"
        >
          {t('nav.bosh_sahifa')}
        </Link>
      </div>
    </div>
  );
};
